import { ThemeColorScaleTypes } from "app/enums";
import generator from "../generator";

const SCALE: Moim.Enums.ThemeColorScaleType = ThemeColorScaleTypes.WHITE;

/**
 * bgColor and textColor for normal type snackbar follows the theme mode.
 */
export default generator({ scale: SCALE });
